import { Component, OnChanges, OnInit, Input, Output, EventEmitter, SimpleChanges } from '@angular/core';
import { ColorEvent } from 'ngx-color';

@Component({
  selector: 'color-picker',
  templateUrl: './color-picker.component.html',
  styleUrls: ['./color-picker.component.sass']
})
export class ColorPickerComponent implements OnChanges, OnInit {
  @Input() hex: string = "#18A0F8";
  @Output() onChange = new EventEmitter<{ hex: string }>();

  DEFAULT_COLORS = ["#18A0F8", "#FBC02D", "#3F5AE3", "#FB2D2D", "#1CBC8C"];

  isDefaultColor: boolean = true;
  isLightColor: boolean = false

  ngOnInit() {
    this.invalidateHex(this.hex);
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hex']) {
      this.invalidateHex(this.hex);
    }
  }

  defaultColorSelected(hex: string) {
    this.hexChanged(hex);
  }

  colorSketchChanged(event: ColorEvent) {
    this.hexChanged(event.color.hex);
  }

  private hexChanged(hex: string) {
    this.invalidateHex(hex);
    this.onChange.emit({ hex });
  }

  private invalidateHex(hex: string) {
    console.log('hex:', hex.toUpperCase().length);
    this.isDefaultColor = this.DEFAULT_COLORS.includes(hex.toUpperCase());
    this.isLightColor = isLightColor(hex);

    console.log('isDefaultColor:', this.isDefaultColor);
  }
}

// adapted from https://stackoverflow.com/a/41491220
function isLightColor(hex: string) {
  let color = hex.charAt(0) === '#' ? hex.substring(1, 7) : hex;
  
  // convert 3-character hex shorthand to 6
  if (color.length == 3) {
    color = color[0] + color[0] + color[1] + color[1] + color[2] + color[2];
  }

  const r = parseInt(color.substring(0, 2), 16);
  const g = parseInt(color.substring(2, 4), 16);
  const b = parseInt(color.substring(4, 6), 16);

  const intensityThreshold = 193; // originally 186; updated to always be white for DEFAULT_COLORS

  return ((r * 0.299) + (g * 0.587) + (b * 0.114)) > intensityThreshold;
}
